export default __webpack_public_path__ + "static/media/Girls_Glasses.c6ca11f3.svg";